/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      finalize: function() {
        // JavaScript to be fired on all pages

        // ScrollReveal activation
        window.sr = ScrollReveal();
        sr.reveal('.reveal', {
          duration: 1000
        });

        // Custom mobile menu
        $('.mobile-button').click(function() {
          $(this).toggleClass('active');
          $('.mobile-overlay').toggleClass('open');
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        // Slick slider
        $('.hero-slider').slick({
          dots: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'ease',
          autoplay: true,
          autoplaySpeed: 2000
        });

        // $('.parallax-window').parallax({imageSrc: 'http://placehold.it/350x150'});

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS



      }
    },
    // About us page, note the change from about-us to about_us.
    'post_type_archive_portfolio': {
      init: function() {
        // JavaScript to be fired on the about us page
        // Get the portfolio categories as a variable

        $('.portfolio__spinner').addClass('no-opacity');



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Standard search for needle in haystack javascript function
        Array.prototype.contains = function ( needle ) {
          for (i in this) {
          if (this[i] == needle) return true;
          }
          return false;
        }

        // Init
        function initPortfolio() {
          getCategories();
          activateClickablePortfolio();
          hashToPortfolioSection();
        }

        initPortfolio();

        function getCategories() {
          $.ajax({
           type: "GET",
           url: templateUrl + "/templates/list-portfolio-categories.php",
           dataType: "html",
           success: function(html) {
                // Create global variable
                portfolioCategories = html;
              }
            });
        }

        function updatePortfolio(portfolioClicked) {

          $('.portfolio__spinner').removeClass('no-opacity');

          $('.four-col-navigation-boxes__box').addClass('no-opacity');

            var taxonomy = 'portfolio_type',
                category = $(portfolioClicked).text(),
                href = portfolioClicked.href,
                hash = category.replace(' ', '-');

            if (href.substr(-1) == '/') {
              href = href.substr( 0, href.length - 1 );
            }

            console.log(category);

            var slug = href.split('/').pop();
            if (slug === 'portfolio') {
              var apiUrl = siteUrl + '/wp-json/wp/v2/portfolio?per_page=100';
            } else {
              var apiUrl = siteUrl + '/wp-json/wp/v2/portfolio?per_page=100&filter[' + taxonomy + ']=' + slug;
            };

            // Update browser URL
            history.pushState('Jeremy Wood - Portfolio - ' + category, 'Jeremy Wood - Portfolio - ' + category, siteUrl + '/portfolio/#' + hash);
            history.replaceState('Jeremy Wood - Portfolio - ' + category, 'Jeremy Wood - Portfolio - ' + category, siteUrl + '/portfolio/#' + hash);

            $.ajax({
              type: 'GET',
              cache: true,
              url: apiUrl,
              dataType: 'json',
              success: function(posts) {
                var html = '';
                $.each( posts, function(index, post ) {
                   //console.log(post);
                   var imageSrc = post.better_featured_image.media_details.sizes.medium_large.source_url;

                   html += '<div class="col-sm-6 col-lg-3">';
                   html += '<div class="four-col-navigation-boxes__box" style="background-image: url(';
                   html += imageSrc;
                   html += ');">';
                   html += '<a href="' + post.link + '">';
                   html += '<div class="four-col-navigation-boxes__box-inner">';
                   html += '<h3 class="four-col-navigation-boxes__box-inner-text">' + post.title.rendered + '</h3>';
                   html += '</div>';
                   html += '</a>';
                   html += '</div>';
                   html += '</div>';

                 });

                // Populate the portfolio listings
                $('.content-area__row').html( portfolioCategories + html );
                // $('.four-col-navigation-boxes__box').removeClass('no-opacity');
                $('.portfolio__spinner').addClass('no-opacity');

              },
              error: function(response)
              {
                console.log(response);
              }

            });
          }

          function hashToPortfolioSection() {

          // If hash exists in URL, click portfolio item
          if ( window.location.hash ) {

            var hash = window.location.hash.replace('#', '');

            // Put all valid hashtags here:
            dataOptions = [
              "Kitchens",
              "Utility-Rooms",
              "Bedrooms",
              "Media-Rooms",
              "Boot-Rooms"
            ];

            // Check current hash for valid hashtags
            if (dataOptions.contains(hash)) {

              // Remove hash, replace with space
              var category = hash.replace("-"," ");

              // Trigger click on hashtag portfolio!
              $('.portfolio__types-list a:contains("' + category + '")').trigger('click');

            }
          }
        }

      // On portfolio category select, populate the portfolio projects
      function activateClickablePortfolio() {
        $( '.content-area' ).on( 'click','.portfolio__types-list a', function( event ) {
          event.preventDefault();
          var portfolioClicked = this;
          updatePortfolio(portfolioClicked);
        });
      }

    }
  }
};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // $(document).ready(function() {
  //   // Slick slider
  //   $('.hero-slider').slick({
  //     dots: true,
  //     infinite: true,
  //     speed: 500,
  //     fade: true,
  //     cssEase: 'ease',
  //     autoplay: true,
  //     autoplaySpeed: 2000
  //   });

  // });

})(jQuery); // Fully reference jQuery after this point.
